import React, { useEffect, useRef } from 'react'
import { CSVDownload, CSVLink } from "react-csv";
import propTypes from 'prop-types';

export const ReactCSV = (props) => {
    const { isExportReady = false, type = "download" } = props;
    const btnRef = useRef(null);

    useEffect(() => {
        if (isExportReady) {
            btnRef.current?.click()
        }

    }, [isExportReady]);

    const types = {
        "download": <CSVDownload {...props} target="_blank" />,
        "link": <CSVLink {...props}><span ref={btnRef} /></CSVLink>
    }

    return (
        <>
            {isExportReady ? types[type] : ""}
        </>
    )
}

ReactCSV.propTypes = {
    isExportReady: propTypes.bool
}